/* ============================================================
   Vindemia — theme scripts (vanilla JS, no dependencies)
   ============================================================ */
(function () {
  'use strict';

  const money = (cents) =>
    (window.Vindemia && window.Vindemia.formatMoney)
      ? window.Vindemia.formatMoney(cents)
      : '$' + (cents / 100).toFixed(2);

  const $  = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));

  /* ---------------- drawer / overlay open + close ---------------- */
  const overlay = $('[data-overlay]');
  function lockScroll(on) { document.body.classList.toggle('no-scroll', on); }

  function openPanel(sel) {
    const el = $(sel);
    if (!el) return;
    el.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.setAttribute('aria-hidden', 'false');
    lockScroll(true);
  }
  function closePanels() {
    $$('[data-panel]').forEach((el) => el.setAttribute('aria-hidden', 'true'));
    if (overlay) overlay.setAttribute('aria-hidden', 'true');
    lockScroll(false);
  }

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-open]');
    if (opener) { e.preventDefault(); openPanel(opener.getAttribute('data-open')); }
    if (e.target.closest('[data-close]')) { e.preventDefault(); closePanels(); }
  });
  if (overlay) overlay.addEventListener('click', closePanels);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closePanels(); });

  /* ---------------- cart drawer render ---------------- */
  function renderCart(cart) {
    const itemsEl = $('[data-cart-items]');
    const countEls = $$('[data-cart-count]');
    const subtotalEl = $('[data-cart-subtotal]');
    const footEl = $('[data-cart-foot]');

    countEls.forEach((el) => {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? '' : 'none';
    });

    if (!itemsEl) return;

    if (cart.item_count === 0) {
      itemsEl.innerHTML = '<div class="cart-empty"><p>Your bag is empty.</p><a class="link-underline" href="/collections/all">Start shopping</a></div>';
      if (footEl) footEl.style.display = 'none';
      return;
    }
    if (footEl) footEl.style.display = '';

    itemsEl.innerHTML = cart.items.map((item) => `
      <div class="cart-line" data-line-key="${item.key}">
        <a href="${item.url}"><img src="${item.image ? item.image.replace(/(\.[^.]+)(\?.*)?$/, '_120x$1$2') : ''}" alt="${item.product_title}" loading="lazy"></a>
        <div>
          <a href="${item.url}"><p class="cart-line__title">${item.product_title}</p></a>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<p class="cart-line__meta">${item.variant_title}</p>` : ''}
          <p class="cart-line__meta">Qty ${item.quantity}</p>
          <button class="cart-line__remove" data-remove="${item.key}">Remove</button>
        </div>
        <div class="cart-line__price">${money(item.final_line_price)}</div>
      </div>`).join('');

    if (subtotalEl) subtotalEl.textContent = money(cart.total_price);
  }

  async function fetchCart() {
    const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
    return res.json();
  }

  async function changeLine(key, quantity) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    });
    return res.json();
  }

  /* remove from drawer */
  document.addEventListener('click', async (e) => {
    const rm = e.target.closest('[data-remove]');
    if (!rm) return;
    e.preventDefault();
    const cart = await changeLine(rm.getAttribute('data-remove'), 0);
    renderCart(cart);
  });

  /* ---------------- add to cart (AJAX) ---------------- */
  $$('[data-product-form]').forEach((form) => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = form.querySelector('[data-add-btn]');
      const original = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: form.querySelector('[name="id"]').value, quantity: 1 })
        });
        if (!res.ok) throw new Error('add failed');
        const cart = await fetchCart();
        renderCart(cart);
        openPanel('[data-cart-drawer]');
        if (btn) btn.textContent = original;
      } catch (err) {
        if (btn) btn.textContent = 'Try again';
        setTimeout(() => { if (btn) btn.textContent = original; }, 1600);
      } finally {
        if (btn) btn.disabled = false;
      }
    });
  });

  /* ---------------- variant picker (product page) ---------------- */
  $$('[data-variant-select]').forEach((select) => {
    const form = select.closest('[data-product-form]');
    const idInput = form && form.querySelector('[name="id"]');
    const priceEl = form && form.querySelector('[data-price]');
    const btn = form && form.querySelector('[data-add-btn]');
    const variants = JSON.parse(select.getAttribute('data-variants') || '[]');

    select.addEventListener('change', () => {
      const v = variants.find((x) => String(x.id) === String(select.value));
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      if (btn) {
        btn.disabled = !v.available;
        btn.textContent = v.available ? btn.getAttribute('data-add-label') : 'Sold Out';
      }
    });
  });

  /* ---------------- cart page quantity ---------------- */
  $$('[data-qty]').forEach((wrap) => {
    const input = wrap.querySelector('input');
    wrap.querySelectorAll('button').forEach((b) => {
      b.addEventListener('click', () => {
        const step = b.getAttribute('data-step') === 'up' ? 1 : -1;
        const val = Math.max(0, (parseInt(input.value, 10) || 0) + step);
        input.value = val;
        input.form && input.form.requestSubmit
          ? input.form.requestSubmit()
          : input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  /* keep drawer count fresh on load */
  document.addEventListener('DOMContentLoaded', () => {
    fetchCart().then(renderCart).catch(() => {});
  });
})();
